import React from 'react';
import PropTypes from 'prop-types';
import ScrollableAnchor from 'react-scrollable-anchor';
import classnames from "classnames";
import {Button} from "reactstrap";
import premium from "../../../images-cp/badge-premium_color.svg";

class ActivityEntry extends React.Component {
    render() {
        const {
            iterationIndex,
            activityLink,
            nameSubject,
            nameSubtopic,
            activityName,
            activityType,
            activityIntent,
            nameClass,
            colourTheme,
            difficulty,
            seen,
            blank,
            id,
            restrictVersion,
            subjectAbbreviation,
            hasPermission,
            inContentPack,
            automaticLanguages,
            withEvaluation,
            isPcPreferred,
        } = this.props;

        let colour = colourTheme && ` ${colourTheme}--light` || ' card--blue';

        if (blank) {
            colour = colourTheme && ` ${colourTheme}--primary` || ' card--blue';
        }

        let lock = restrictVersion;

        let difficultyLevelName = '';

        switch (difficulty) {
            case 'A':
                difficultyLevelName = 'Nízká obtížnost';
                break;
            case 'B':
                difficultyLevelName = 'Střední obtížnost';
                break;
            case 'C':
                difficultyLevelName = 'Vysoká obtížnost';
                break;
        }

        let automaticLanguagesTitle = '';

        if (automaticLanguages && automaticLanguages.length > 0) {
            automaticLanguagesTitle = 'Cvičení s překladem: ' + automaticLanguages.join(', ');
        }

        return (
            <ScrollableAnchor id={'activity-' + id}>
                <a href={activityLink}
                   className={"card card-activity card--bordered " + colour + (seen ? ' card--seen' : '') + (blank ? ' card--blank' : '') + (lock ? ' restricted' : '')}
                   title={hasPermission === false ? 'Cvičení není dostupné pro vaši roli.' : ''}>
                    {!blank &&
                        <div className="card-bg"/>
                    }
                    {!blank &&
                        <div className="card-header">
                            <div
                                className={"card-type " + activityType.key.toLowerCase() + " " + activityIntent.key.toLowerCase()}/>
                            <div className="card-meta">
                                <div className="card-category">
                                    <strong>{activityType.name}</strong>{activityIntent.name && (' | ' + activityIntent.name)}
                                </div>
                                {inContentPack && <div className={'d-inline-block ps-3 vertical-super'}>
                                    {premium && <img src={premium} alt={'Premium'} width={25} height={25}/>}
                                </div>
                                }
                            </div>
                        </div>
                    }
                    {!blank &&
                        <div className="card-body">
                            <h3 className="card-title">
                                {activityName}
                            </h3>
                        </div>
                    }
                    {!blank &&
                        <>
                            <div className="card-footer">
                                {!lock && <div>{nameClass}<span
                                    className="font-weight-normal"> {nameSubject && (' | ' + nameSubject)}{nameSubtopic && (' | ' + nameSubtopic)}</span>
                                </div>}
                                {lock && <div className={'d-flex align-items-center'}>
                                    {colourTheme && subjectAbbreviation && <Button
                                        className={classnames("subject-tag subject-tag-sm me-2 text-white", colourTheme)}>
                                        {subjectAbbreviation}
                                    </Button>}
                                    <div>{nameSubject}</div>
                                </div>}
                                {restrictVersion && <div className={'ps-2'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                        <g id="Back_Circle_Button" data-name="Back Circle Button"
                                           transform="translate(30 30) rotate(180)">
                                            <circle id="Ellipse_593" data-name="Ellipse 593" cx="15" cy="15" r="15"
                                                    fill="#3a3a3a"/>
                                            <g id="Arrow_Go" data-name="Arrow Go"
                                               transform="translate(16 20) rotate(180)">
                                                <path id="Path_4663" data-name="Path 4663" d="M4,0,0,5l4,5"
                                                      transform="translate(4 10) rotate(180)" fill="none" stroke="#fff"
                                                      stroke-linecap="round" stroke-width="1.5"/>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                }
                                {hasPermission === false && <div className={'ps-2'}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
                                        <g>
                                            <g>
                                                <path fill="#3a3a3a"
                                                      d="M8.633 6.4H4.366V4.267c0-1.177.957-2.134 2.134-2.134 1.176 0 2.133.957 2.133 2.134zM6.5 12.8a1.066 1.066 0 1 1-.002-2.132A1.066 1.066 0 0 1 6.5 12.8zm4.266-6.4V4.267a4.267 4.267 0 0 0-8.533 0V6.4H1.166A1.07 1.07 0 0 0 .1 7.467v7.466C.1 15.52.58 16 1.166 16h10.667a1.07 1.07 0 0 0 1.067-1.067V7.467A1.07 1.07 0 0 0 11.833 6.4z"/>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                }
                            </div>
                            {!lock && <div className="card-footer-icon">
                                {difficulty && <div className={"d-inline-block card-difficulty " + difficulty}
                                               title={difficultyLevelName}/>}
                                {withEvaluation &&
                                    <div className={"d-inline-block card-evaluation"} title={'Cvičení s vyhodnocení'}/>}
                                {automaticLanguages && automaticLanguages.length > 0 &&
                                    <div className={"d-inline-block card-translation"} title={automaticLanguagesTitle}/>}
                                {isPcPreferred &&
                                    <div className={"d-inline-block card-pc-preferred"} title={'Doporučujeme vyplnit na PC'}/>}
                            </div>}
                        </>
                    }
                </a>
            </ScrollableAnchor>
        );
    }
}

ActivityEntry.propTypes = {
    iterationIndex: PropTypes.number.isRequired,
    nameClass: PropTypes.string.isRequired,
    nameSubject: PropTypes.string.isRequired,
    nameSubtopic: PropTypes.string,
    activityLink: PropTypes.string.isRequired,
    activityName: PropTypes.string.isRequired,
    activityType: PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }),
    activityIntent: PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }),
    withEvaluation: PropTypes.bool,
    colourTheme: PropTypes.string,
    difficulty: PropTypes.string,
    subjectAbbreviation: PropTypes.string,
    id: PropTypes.number.isRequired,
    restrictVersion: PropTypes.bool,
    hasPermission: PropTypes.bool,
    inContentPack: PropTypes.bool,
    automaticLanguages: PropTypes.array,
    isPcPreferred: PropTypes.bool,
};

export default ActivityEntry;
